'use strict';
var _ = require('lodash');
var $ = require('jquery');
var Backbone = require('backbone');
var template = require('../../templates/voteconfirmation.ejs');
var VoteOptionView = require('./voteoption');

module.exports = Backbone.View.extend({
    className: 'view-voteconfirmation',
    events: {
        'click .submit': 'executeRecaptcha',
        'click .close': 'closeModal'
    },
    $buttonEl: null,
    recaptchaToken: null,
    contestantsViews: [],

    /**
     * Initialize Confirmation Modal View
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        this.optionsList = options.optionsList;
        this.votes = this.optionsList.getTotal();
        this.maxVotes = this.optionsList.maxVotes;
        this.countdownViewTop = options.countdownViewTop;
        this.countdownViewBottom = options.countdownViewBottom;
        this.cms = options.cms;
        this.copyCms = options.copyCms;

        // check if recaptcha is enabled
        this.recaptchaEnabled = this.model.recaptcha.display === 'true';
    },
    /**
     * Render Confirmation Modal View
     */
    render: function () {
        var model = _.clone(this.model);
        var modal = this.copyCms.get('text').modal;
        const selectedContestants = this.getSelectedContestants();
        model.votes_text = this.getRemainingVotes();
        model.paragraph = (this.votes === 0) ? model.zero_votes_paragraph : model.paragraph;
        model.submitVotes = this.submitVotes;
        model.ariaLabelSubmitButton = this.getSubmitVotesButtonText(selectedContestants);
        model.modal = modal;
        
        this.$el.html(template(model));
        this.addContestants(selectedContestants);

        // store reference
        this.$buttonEl = this.$el.find( 'button' );
        this.$body = $( 'body' );
        this.$container = $( '#ContainerTelescopeAppDWTS' );

        return this;
    },
    /**
     * [ renderedToDOM ]
     */
    renderedToDOM: function() {
        this.$('.confirm-countdown.top').html(this.countdownViewTop.render().$el);
        this.$('.confirm-countdown.bottom').html(this.countdownViewBottom.render().$el);
        this.generateRecaptcha();
    },
    /**
     * [ getRemainingVotes ]
     */
    getRemainingVotes: function() {
        this.votes = this.maxVotes - this.optionsList.getTotal();
        var model = _.clone(this.model);
        model.votes_text = (this.votes === 1) ? model.single_vote_text : model.votes_text;
        model.votes_text = (this.votes === 0) ? model.zero_vote_text : model.votes_text;
        var votesWord = (this.votes === 1) ? this.model.vote : this.model.votes;
        return model.votes_text.replace('{{VOTES}}', '<span class="votes">'+this.votes+' '+votesWord+'</span>');
    },
    /**
     * [ getSelectedContestants ]
     */
    getSelectedContestants: function() {
        var elms = [];
        var models = this.optionsList.models;
        models.sort(function(a,b){
            if(a.get('voteCount') < b.get('voteCount')) {
                return 1;
            } else if(a.get('voteCount') > b.get('voteCount')) {
                return -1;
            } else {
                if(a.get('name') > b.get('name')) {
                    return 1;
                } else if(a.get('name') < b.get('name')) {
                    return -1;
                } else {
                    return 0;
                }
            }
        });

        _.each(models, function(value) {
            if(value.get('voteCount') > 0) {
                elms.push( value );
            }
        });

        return elms;
    },
    /**
     * [ addContestants ]
     * Adds the array of selected contestants to the DOM
     * @param {array} contestants
     * @return {undefined}
     */
    addContestants: function(contestants) {
        const elms = [];
        _.each(contestants, function(value) {
            var contestant = new VoteOptionView({
                model: value,
                type: 'confirm',
                optionsList: this.optionsList,
                copyCms: this.copyCms
            }).render().$el;
            elms.push(contestant);
        }.bind(this));

        this.contestantsViews = elms;

        this.$('.contestants').append(elms);
        this.$('.contestants').addClass('contestants-'+this.optionsList.models.length);
    },
    /**
     * [ submitVotes ]
     */
    submitVotes: function() {
        // check if there is an existing recaptcha token before submission
        if( this.recaptchaEnabled && !this.recaptchaToken ) return;

        this.trigger('submitVotes', { token: this.recaptchaToken });
    },
    /**
     * [ generateRecaptcha ]
     * reference: https://developers.google.com/recaptcha/docs/display
     */
    generateRecaptcha: function() {

        var $invi = $('#inviRecaptcha');
        if(!$invi) return;

        // render the recaptcha
        this.recaptchaID = window.grecaptcha.render( 'inviRecaptcha', {
            'sitekey': this.model.recaptcha.site_key,
            'callback': this.handleRecaptchaResponse.bind( this ),
            'expired-callback': this.handleExpiredRecaptcha.bind( this )
        });
    },
    /**
     * [ executeRecaptcha ]
     */
    executeRecaptcha: function (e) {
        e.preventDefault();
        window.grecaptcha.execute( this.recaptchaID );
    },
    /**
     * [ resetRecaptcha ]
     */
    resetRecaptcha: function() {
        window.grecaptcha.reset( this.recaptchaID );
    },
    /**
     * [ handleRecaptchaResponse ]
     */
    handleRecaptchaResponse: function( res ) {
        this.recaptchaToken = res;
        this.$buttonEl.attr( 'disabled', true );
        this.submitVotes();
    },
    /**
     * Disable the submit button when recaptcha expires
     */
    handleExpiredRecaptcha: function() {
        this.recaptchaToken = null;
        this.$buttonEl.attr( 'disabled', false );
    },
    /**
     * [ closeModal ]
     */
    closeModal: function(e) {
        e.preventDefault();
        this.trigger('closeModal', {});

    },
    /**
     * Overwrite Backbone remove function
     */
    remove: function(){
        this.contestantsViews.forEach( function(view) {
            view.remove();
        });

        this.resetRecaptcha();
        this.countdownViewTop.remove();
        this.countdownViewBottom.remove();
        return Backbone.View.prototype.remove.call( this );
    },
    /**
     * getSubmitVotesButtonText
     * Returns a string to be used for the aria-label on the submit button to aid users with screen readers
     * @param {array} contestants
     * @return {string} string containing a list of contestants and their respective vote counts
     */
    getSubmitVotesButtonText(contestants) {
        const contestantsStr = contestants.map(function(contestant) {
            const name = contestant.get('name');
            const voteCount = contestant.get('voteCount');
            const voteStr = voteCount == 1 ? 'vote' : 'votes';

            return `${name}, ${voteCount} ${voteStr}`;
        }).join(',');
        const submitStr = this.model.submit;
        return `${submitStr} for ${contestantsStr}`;
    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/voteconfirmation.js